import * as React from "react";
import { Component } from "react";
import Viewer from "../../component/viewer/Viewer";
import { Study } from "../../api/StudyApi";
import { RouteComponentProps } from "react-router-dom";
import { AuthManager } from "../../component/auth/AuthContext";
import "../study-detail/study-detail.scss";
import { AiResult } from "../../api/EvalWorkflowApi";
import { DisplayMode } from "../../component/viewer/DisplayMode";
import { demo } from "../../component/viewer/AiDisplayPreferences";
import i18n from "i18next";
import ViewportImage from "../../component/viewer/ViewportImage";

interface DemoStudyDetailProps extends RouteComponentProps<any> {
  authManager: AuthManager;
  study: Study;
  aiResult?: AiResult;
  actions: JSX.Element;
}

interface DemoStudyDetailState {
  study?: Study;
  viewportImages?: Array<ViewportImage>;
}

export default class DemoStudyDetail extends Component<DemoStudyDetailProps, DemoStudyDetailState> {
  constructor(props: DemoStudyDetailProps) {
    super(props);
    this.state = {};
  }

  UNSAFE_componentWillReceiveProps(nextProp: DemoStudyDetailProps) {
    this.refreshStudy(nextProp.study);
  }

  componentDidMount() {
    this.refreshStudy(this.props.study);
  }

  refreshStudy(study: Study) {
    const viewportImages = new Array<ViewportImage>();

    study.series.forEach((s) =>
      s.images.forEach((img) => {
        const imgElt = new ViewportImage(img, []);
        viewportImages.push(imgElt);
      })
    );

    this.setState({
      study,
      viewportImages: viewportImages,
    });
  }

  render() {
    if (this.state.study && this.state.viewportImages) {
      return (
        <div className="study-detail">
          <Viewer
            study={this.state.study}
            observations={this.state.study.observations}
            images={this.state.viewportImages}
            authManager={this.props.authManager}
            aiDisplayPreferences={demo()}
            display={DisplayMode.demo()}
            actions={() => this.props.actions}
          />
        </div>
      );
    } else {
      return <div>{i18n.t("global.loading")}</div>;
    }
  }
}
